import { domToReact, Element } from 'html-react-parser';
import { cloneDeep } from 'lodash-es';
import * as React from 'react';
import { ICommentReplacerData } from './CommentsParsers';
import { IAlterDefaultOptions, parseOptions } from './Templater';

const ComplexReplacements: ((
  domNode: Element,
  Component: React.ComponentType,
  customOptions?: IAlterDefaultOptions,
  commentsData?: ICommentReplacerData,
) => React.ReactNode)[] = [
  (domNode, _, customOptions, commentsData) => {
    if (
      domNode.attribs['data-prevent-parse'] &&
      domNode.attribs['data-prevent-parse'].trim() === 'true'
    ) {
      return null;
    }
    if (
      domNode.attributes.find((current) => current.name === 'data-fragment')
    ) {
      const children = domToReact(
        cloneDeep(domNode.children),
        parseOptions(customOptions, commentsData),
      );
      return <>{children}</>;
    }
    return false;
  },
];

export default ComplexReplacements;
